import * as React from 'react';

import { Button } from 'components/bootstrap';
import { Collapsible, Col, DataWell } from 'common/components';
import type { InvestigationsDetailsAPIType } from 'security-app/hooks/api/investigationsAPI.types';
import User from 'security-app/components/Assets/AssetModals/AssetDetailsDrawer/UserData';
import Machine from 'security-app/components/Assets/AssetModals/AssetDetailsDrawer/MachineData';
import type {
  AssetAPIType,
  AssetDetailsType,
  MachineAssetAPIType,
  UserAssetAPIType,
} from 'security-app/hooks/api/assetsAPI.types';

const componentByType = {
  machine: (machine: AssetAPIType<MachineAssetAPIType>) => <Machine machineAsset={machine} />,
  user: (user: AssetAPIType<UserAssetAPIType>) => <User userAsset={user} />,
};

type Props = {
  investigation: InvestigationsDetailsAPIType;
};

const Assets = ({ investigation }: Props) => {
  const { associated_assets } = investigation;

  return (
    <DataWell $color="content">
      <Col>
        <h2>Assets</h2>
        <Col $gap={0}>
          {associated_assets.length < 1 ? (
            <div>There are no associated assets to show.</div>
          ) : (
            associated_assets.map((asset: AssetAPIType<AssetDetailsType>) => (
              <Collapsible
                key={asset.id}
                title={
                  <Button bsStyle="link">
                    <b>{asset.name}</b>
                  </Button>
                }>
                <Col $gap="lg">{componentByType[asset.details.type](asset)}</Col>
              </Collapsible>
            ))
          )}
        </Col>
      </Col>
    </DataWell>
  );
};

export default Assets;
